module.exports = __webpack_public_path__ + "media/common/logo_tech-7b983114.svg";